import React from 'react'
import Lottie from 'react-lottie'

import PropTypes from 'prop-types'

import Location from '@smartcoop/styles/assets/animations/location.json'

import { Container } from './styles'

const lottieStyle = {
  height: '100%',
  alignSelf: 'center'
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: Location
}

const AnimatedLocation = () => (
  <Container>
    <Lottie options={ defaultOptions } isClickToPauseDisabled style={ lottieStyle } width={ 50 }/>
  </Container>
)

AnimatedLocation.propTypes = {
}

AnimatedLocation.defaultProps = {
}


export default AnimatedLocation
